<template>
    <div id="docmannagerID">
        <a-card title="文档管理">
            <div class="box_left">
                <menuTree :mkey="selectNodeInfo.cMkey" @handleNodeSelect="handleNodeSelected"></menuTree>
            </div>
            <div class="box_right">
                <a-breadcrumb class="breadCrumb">
                    <a-breadcrumb-item>{{selectNodeInfo.pTitle}}</a-breadcrumb-item>
                    <a-breadcrumb-item>{{selectNodeInfo.cTitle}}</a-breadcrumb-item>
                </a-breadcrumb>
                <!-- API列表 -->
                <docList 
                    v-show="type == 'doc_list'" 
                    ref="docListID"
                >
                </docList>
                <!-- 普通菜单 -->
                <a-result
                    v-if="type == 'no_result'"
                    title="菜单未选中！"
                    sub-title="选中类型为'文档列表'，'单文档'的菜单进行文档的新增或编辑操作"
                >
                </a-result>
                <!-- 普通菜单 -->
                <a-result
                    v-if="type == 'menu'"
                    title="普通菜单，没有详情内容"
                >
                </a-result>
                <!-- 文档预览 -->
                <docview 
                    v-show="type == 'single_doc'"
                    ref="docViewID"
                >
                </docview>
               
            </div>
        </a-card>
    </div>
</template>

<script>
import menuTree from './comp/menu'
import docList from './comp/doclist'
import docview from './comp/docview'
export default {
    data() {
        return {
            selectNodeInfo:{
                pTitle:'',
                pHook:'',
                cTitle:'',
                cMenucode:'',
                cMkey:'',
                chookconfig:''
            },
            type:'no_result',
        };
    },
    mounted(){
        //页面加载是，选中上次选择的item
        let lastItem = localStorage.getItem('docManagerSelectItem');
        if(lastItem){
            lastItem = JSON.parse(lastItem);
            this.selectNodeInfo = lastItem;
        }
        this.getPageType();
    },
    destroyed(){
    },
    methods:{

        handleNodeSelected(parentTitle,parentHookconfig,cN){
            //菜单选中，需要按选择类型控制显示文档编辑
            this.selectNodeInfo.pTitle = parentTitle;
            this.selectNodeInfo.pHook = parentHookconfig;
            this.selectNodeInfo.cTitle = cN.title;
            this.selectNodeInfo.cMenucode = cN.menucode;
            this.selectNodeInfo.cMkey = cN.key;
            this.selectNodeInfo.chookconfig = cN.hookconfig;
            this.getPageType();
            //本地存储已选择项，页面返回的时候加载已选择项
            localStorage.setItem('docManagerSelectItem',JSON.stringify(this.selectNodeInfo));
        },
        getPageType(){
            let tempHookConfig = this.selectNodeInfo.chookconfig;
            //hookconfig  0 文档菜单 3 API菜单 1列表 2 单文档
            if(tempHookConfig == '2'){
                //显示单文档编辑
                this.type = 'single_doc'
                this.$refs.docViewID.getContent(this.selectNodeInfo)

            }
            else if(tempHookConfig == '1'){
                //显示接口列表
                this.type = 'doc_list'
                this.$refs.docListID.getAppSumData(this.selectNodeInfo)
            }
            else if(tempHookConfig == '4'){
                //显示接口列表
                this.type = 'menu'
            }
            else{
                //显示提示
                this.type = 'no_result'
            }
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 522) + 'px'
        }
    },

    components:{
        menuTree,
        docList,
        docview
    }
};
</script>

<style lang="less" scoped>
   
    .doc_content{
        min-width: 1000px;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .box_left{
        width: 300px;
        height: 100%;
        float: left;
        margin-top: 0;
        margin-bottom: 10px;
        position: relative;
        overflow: hidden;
    }
    .box_right{
        width:calc(100% - 300px);
        height: 100%;
        min-height: 700px;
        float: left;
        position: relative;
        border-left: 1px solid lightgray;
    }

    .ant-card-body{
        padding: 0;
    }

    .breadCrumb{
        margin: 6px 20px;
    }
</style>

<style>
    #docmannagerID .ant-card-body{
        padding: 4px 24px;
    }
</style>

